import '../slim.jquery';
import '../daterangepicker';
lottie.loadAnimation({
    container: document.getElementById('lottie'),
    renderer: 'svg',
    loop: true,
    autoplay: true,
    path: 'particle_logo.json' // the path to the animation json
});

jQuery(function() {

    M.AutoInit();
    
    $('.datepicker').datepicker({
        firstDay: true, 
        format: 'dd-mm-yyyy',
        i18n: {
            months: ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"],
            monthsShort: ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"],
            weekdays: ["Domingo","Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado"],
            weekdaysShort: ["Dom","Seg", "Ter", "Qua", "Qui", "Sex", "Sab"],
            weekdaysAbbrev: ["D","S", "T", "Q", "Q", "S", "S"],
            cancel: 'Cancelar',
            clear: 'Limpar',
            done: 'Ok'
        }
    });
    $('.dropdown-trigger').dropdown({
        constrainWidth: false,
    });

    var TelMaskBehavior = function (val) {
        return val.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009';
      },
      spOptions = {
        onKeyPress: function(val, e, field, options) {
            field.mask(TelMaskBehavior.apply({}, arguments), options);
          }
      };
    

    $('.cep').mask('00000-000');
    $('.cnpj').mask('00.000.000/0000-00');
    $('.cpf').mask('000.000.000-00');
    $('.telefone').mask(TelMaskBehavior, spOptions);

    $('input[type=range]').on('input', function () {
        $(this).trigger('change');
        $(this).parents('.custom-range-field').find('.label .value').html($(this).val()+'%');
    });

    $('.close-alert').click(function(){
        $(this).parent('.alert').fadeOut();
    });
  
    $('.select2').select2();

    

    $(".select_modal_bairro").select2({
        dropdownParent: $("#modal-bairro .modal-content")
      });
    
    var url = $('base').attr('href');

    //Imagem default
    $('.empreendimento-image').slim({
        ratio: '16:9',
        minSize: {
            width: 800,
            height: 485,
        },
        download: false,
        label: '<i class="material-icons">image</i> <br />Adicionar Capa',
        buttonConfirmLabel: 'Ok',
    });

    $('.comunicado-image').slim({
        ratio: '1:1',
        minSize: {
            width: 800,
            height: 800,
        },
        download: false,
        label: '<i class="material-icons">image</i> <br />Adicionar Imagem',
        buttonConfirmLabel: 'Ok',
    });

    $('.user-image').slim({
        ratio: '1:1',
        minSize: {
            width: 400,
            height: 400,
        },
        download: false,
        label: '<i class="material-icons">image</i> <br />Imagem perfil',
        buttonConfirmLabel: 'Ok',
    });

    $('.incorporadora-image').slim({
        ratio: '16:9',
        minSize: {
            width: 800,
            height: 485,
        },
        download: false,
        label: 'Clique ou arraste a imagem.',
        buttonConfirmLabel: 'Ok',
      });


    //Estados e cidades
    $(function(){
        $('select[name="estado_id"]').change(function(){
            if( $(this).val() ) {
                $.getJSON(url+'/getCidades/'+$(this).val(), function(j){
                    var options = '<option value="">Selecione a cidade</option>';
                    for (var i = 0; i < j.length; i++) {
                    options += '<option value="' + j[i].id + '">' + j[i].nome + '</option>';
                    }
                    $('select[name="cidade_id"]').html(options)
                });
            } 
        });
    });
    
    if( $('#estado option:selected').val()) {
        var val = $('#estado option:selected').val();
        $.getJSON(url+'/getCidades/'+ val, function(cidades){
            var options = '<option value="">Selecione a cidade</option>';
                for (var i = 0; i < cidades.length; i++) {
                options += '<option value="' + cidades[i].id + '">' + cidades[i].nome + '</option>';
            }

            $('select[name="cidade_id"]').html(options)
            
            $("select#cidade").val($("#cidade").data('cidade'));

            if($("#cidade").data('cidade')){
                $.getJSON(url+'/getBairros/'+ $("#cidade").data('cidade'), function(bairros){
                    console.log(bairros.length);

                    var options = '<option value="">Selecione o bairro</option>';
                        for (var i = 0; i < bairros.length; i++) {
                        options += '<option value="' + bairros[i].id + '">' + bairros[i].nome + '</option>';
                    }
                    $('select[name="bairro_id"]').html(options)

                    $("select#bairro_id").val($("#bairro_id").data('bairro'));
                });
            }
        });
    }

    $(function(){
        $('select[name="cidade_id"]').change(function(){
            if( $(this).val() ) {
                $.getJSON(url+'/getBairros/'+$(this).val(), function(j){
                    var options = '<option value="">Selecione o bairro</option>';
                    for (var i = 0; i < j.length; i++) {
                    options += '<option value="' + j[i].id + '">' + j[i].nome + '</option>';
                    }
                    $('select[name="bairro_id"]').html(options)
                });
            } 
        });
    });


    //Default datatables
    var table = $('.datatables').DataTable({
        language: {
            "sEmptyTable": "Nenhum registro encontrado",
            "sInfo": "_START_-_END_ de _TOTAL_",
            "sInfoEmpty": "Mostrando 0 até 0 de 0 registros",
            "sInfoFiltered": "(Filtrados de _MAX_ registros)",
            "sInfoPostFix": "",
            "sInfoThousands": ".",
            "sLengthMenu": "_MENU_ Linhas por página",
            "sLoadingRecords": "Carregando...",
            "sProcessing": "Processando...",
            "sZeroRecords": "Nenhum registro encontrado",
            "sSearch": "",
            "searchPlaceholder": "Filtrar",
            "oPaginate": {
                "sNext": '<i class="material-icons">keyboard_arrow_right</i>', // or '→'
                "sPrevious": '<i class="material-icons">keyboard_arrow_left</i>',
                "sFirst": "Primeiro",
                "sLast": "Último"
            },
            "oAria": {
                "sSortAscending": ": Ordenar colunas de forma ascendente",
                "sSortDescending": ": Ordenar colunas de forma descendente"
            }
        },
        "paging": true,
        "searching": true,
        "ordering": true,
        "info": true,
        "dom": 't<"bottom"lip>',
        stateSave: true
    });

    //Remote field search datatable
    $('#search-table-field').keyup( function() {
        table.search($(this).val(), true, false).draw();
    });
    $(".search-table-button").click(function() {
        $('.search-table-field').toggleClass("open");
    });

    //Default maps locationpicker
    if(($("#longitude").val() != '') || ($("#longitude").val() != '')){
        var lat = $("#latitude").val();
        var lng = $("#longitude").val();
        var zoom = 18;
    } else {
      var lat = -15.7217175;
      var lng = -48.0774427;
      var zoom = 12;
    }
    $('#mapa').locationpicker({
      location: {latitude: lat, longitude: lng},
      zoom: zoom,
      inputBinding: {
            latitudeInput: $('#latitude'),
            longitudeInput: $('#longitude'),
            locationNameInput: $('#enderecoGmaps')
        },
      enableAutocomplete: true,
    });


    /* BUSCA DE ENDERECO POR CEP */
    $('#cep').keyup(function() {
        var cep = $(this).val().replace(/[^\d]+/g,'');
        if(cep.length == 8){
            var verify = $.trim(cep);
            $.ajax({
                url: url+"/getCep/"+verify,
                dataType: 'json',
                type: 'GET',
                success: function(resultadoCEP) {
                    if(resultadoCEP.status){
                        if(resultadoCEP.bairro){
                            $('#bairro').val(unescape(resultadoCEP.bairro)).attr('readonly', true).next().addClass('active');
                        } else {
                            $('#bairro').val('').attr('readonly', false).next().addClass('active');
                        }
                        $("#estado").val(resultadoCEP['estado_id']).select2();

                        var options = '<option value="">Selecione a cidade</option>';
                            for (var i = 0; i < resultadoCEP['cidades'].length; i++) {
                            options += '<option value="' + resultadoCEP['cidades'][i].id + '">' + resultadoCEP['cidades'][i].nome + '</option>';
                        }
                        $('select[name="cidade_id"]').html(options)
                        $("select#cidade").val(resultadoCEP['cidade_id']);


                        var options = '<option value="">Selecione o Bairro</option>';
                            for (var i = 0; i < resultadoCEP['bairros'].length; i++) {
                            options += '<option value="' + resultadoCEP['bairros'][i].id + '">' + resultadoCEP['bairros'][i].nome + '</option>';
                        }
                        $('select[name="bairro_id"]').html(options)
                        $("select#bairro_id").val(resultadoCEP['bairro_id']);


                        $('#endereco').val(unescape(resultadoCEP["tipo_logradouro"]) + " " + unescape(resultadoCEP["logradouro"])).next().addClass('active');

                        $("#enderecoGmaps").val(unescape(resultadoCEP["tipo_logradouro"]) + " " + unescape(resultadoCEP["logradouro"])).focus();
                    } 
                },
                error: function(xhr, ajaxOptions, thrownError) {
                }
            });
        }

    });

    $('body').removeClass('overflow-hidden');

    $('.page-loader').fadeOut();

});
